"use client";
// @ts-strict-ignore
import { Card, Flex, mediaQuery } from "@hubble/web";
import NextImage from "components/parts/NextImage";
import styled from "styled-components";

const DESKTOP_CARD_HEIGHT = "220px";
const MOBILE_CARD_HEIGHT = "360px";

export const GeminiPromoBannerCard = styled(Card)`
  display: inline-block !important;
  height: ${DESKTOP_CARD_HEIGHT};
  width: 100%;
  box-sizing: border-box;
  border-radius: 24px !important;
  @media ${mediaQuery.mobileXsDown} {
    min-height: ${MOBILE_CARD_HEIGHT};
    height: max-content;
    width: 100%;
  }
` as typeof Card;

export const GeminiPromoBannerCardContent = styled(Flex)`
  margin: 0 1.5rem;
  height: 100%;
  max-width: 1200px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  @media ${mediaQuery.mobileXsDown} {
    margin: 1.5rem 0.75rem;
    flex-direction: column;
    gap: 1rem;
    justify-content: flex-start;
    align-items: flex-start;
  }
` as typeof Flex;

export const BannerImage = styled(NextImage)`
  @media ${mediaQuery.tabletMdDown} {
    display: none;
  }

  @media ${mediaQuery.mobileXsDown} {
    display: inline;
    order: 3;
    align-self: center;
    margin-top: 0.5rem;
  }
` as typeof NextImage;

export const TextNodeContainer = styled(Flex)`
  width: 360px;
  gap: 0.5rem;

  @media ${mediaQuery.tabletMdDown} {
    width: 100%;
  }
` as typeof Flex;

export const CTAContainer = styled(Flex)`
  min-width: 160px;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  @media ${mediaQuery.mobileXsDown} {
    flex-direction: row-reverse;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
  }
` as typeof Flex;
